import React from 'react';
import { Handler } from 'ml-component-web';

import './faq.css';

export default class FAQHandler extends Handler {

    renderHandler() {
        return (
            <div className="page-content container">
                <h1>FAQ</h1>
                <p>If we don't already have an answer to your question, please <a href="mailto:support@mybabybio.com">email us</a>.</p>
                <h2>Permissions</h2>
                <h3>Who can see my child's memories?</h3>
                <p>The only people that can view your child's memories are the people that you explicitly invite to MyBabyBio and grant access. Each child can be managed independently and different access can be granted to each person.</p>
                <h3>What are the different permission levels?</h3>
                <p>We currently offer 3 different permission levels:</p>
                <ul>
                    <li><strong>Can see and change everything</strong> - A user with this access has the same permissions as you so they can invite other family and friends as well as view all your child's memories.</li>
                    <li><strong>Can see all memories</strong> - A user with this access is able to add memories and view all your child's memories.</li>
                    <li><strong>Can only see their own memories</strong> - A user with this access is able to add memories, but can only view the memories that they have added.</li>
                </ul>
                <h2>Security</h2>
                <h3>How do I know my memories are secure?</h3>
                <p>All your memories are backed up safely and securely in the cloud using Google's state of the art encryption. As soon as a photo leaves your phone it is encrypted and transferred securely using 256 bit SSL - the highest standard of online encryption.  When it reaches the cloud, it is stored encrypted "at rest" to make sure it is completely secure.</p>
                <h2>Pricing</h2>
                <h3>What do I get for free?</h3>
                <p>We offer a free storage allowance of 1GB to all our families so that you can experiment and fall in love with MyBabyBio before you have to pay anything.  This allowance is enough for approximately 500 photos or 10 minutes of HD video.</p>
                <h3>Why do you charge for MyBabyBio?</h3>
                <p>We want to keep your memories as safe and secure as possible without compromising your privacy, so rather than introduce advertising, we charge a small subscription fee to cover our costs.  This is directly linked to the amount of storage space that you're using, so you'll never pay for more than you need.</p>
                <h3>How much do you charge for MyBabyBio?</h3>
                <p>Beyond our free storage allowance, we offer 4 different subscription levels based on the amount of storage space that you're using:</p>
                <table className="faq-price-table">
                    <tr>
                        <th>Storage space</th>
                        <th>Price</th>
                    </tr>
                    <tr>
                        <td>Up to 10GB</td>
                        <td>£1.29 per month</td>
                    </tr>
                    <tr>
                        <td>Up to 20GB</td>
                        <td>£2.29 per month</td>
                    </tr>
                    <tr>
                        <td>Up to 50GB</td>
                        <td>£3.99 per month</td>
                    </tr>
                    <tr>
                        <td>Unlimited</td>
                        <td>£5.99 per month</td>
                    </tr>
                </table>
                {/* <h2>Comparison</h2> */}
                {/* <h3>Why should I use MyBabyBio instead of WhatsApp?</h3> */}
                {/* <p>Whilst WhatsApp lets you share photos and videos privately, did you know that you can't transfer your message history from an Android phone to an Apple phone or vice versa? We suggest you think twice about relying on WhatsApp's backup as the only place to back up your most precious memories.</p> */}
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/FAQHandler.js
 **/